// /src/components/modals/ImovelEditorModal/EditorProcessing.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FiLoader, FiCpu } from 'react-icons/fi';

export const EditorLoading = () => (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/90">
        <FiLoader className="animate-spin text-accent" size={60} />
    </div>
);

export const EditorSyncOverlay = ({ isVisible }) => (
    <motion.div 
        initial={{ opacity: 0 }} 
        animate={{ opacity: isVisible ? 1 : 0 }} 
        className={`fixed inset-0 z-[1000] bg-black/95 backdrop-blur-2xl flex flex-col items-center justify-center ${!isVisible && 'pointer-events-none'}`}
    >
        <FiCpu className="animate-spin mb-6 text-accent" size={80} />
        <h2 className="text-3xl font-black uppercase tracking-[0.5em] text-white">Sincronizando</h2>
    </motion.div>
);